import React from "react";
import IntlMessages from "@util/IntlMessages";
import GlobalSettings from "../../WidgetsSettings/GlobalSettings/GlobalSettingsModal";
import AdSenseSettings from "../AdSenseSettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const AdSenseModal = ({ settings }) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings value={settings} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <AdSenseSettings settings={settings} />
         </TabPane>
      </Tabs>
   );
};

export default AdSenseModal;
